export const MENSAJE_REVISION_PENDIENTE = 'Mercadería recibida. Revisión de costos pendiente de autorización';

export function interpretarRecepcion(data) {
  const resolved = data && Object.prototype.hasOwnProperty.call(data, 'cambios_costo')
    ? data
    : (data && data.data) || data || {};
  const revisionPendiente = resolved.revision_costo_pendiente === true;
  const cambios = revisionPendiente || !Array.isArray(resolved.cambios_costo)
    ? []
    : resolved.cambios_costo;
  return {
    estado: resolved.estado || null,
    procesados: resolved.productos_procesados,
    cambios,
    revisionPendiente,
    incidente: resolved.incidente_revision === true,
    mensaje: resolved.mensaje || (revisionPendiente ? MENSAJE_REVISION_PENDIENTE : null)
  };
}

export function describirResultado(data, cambios) {
  const src = data && (data.aplicados || data.pendientes || data.rechazados || data.cerrados)
    ? data
    : (data && data.data) || {};
  const mapear = (lista) => (Array.isArray(lista) ? lista : []).map((item) => {
    const cambio = (cambios || []).find((fila) => fila.producto_id === item.producto_id);
    return {
      ...item,
      nombre: (cambio && (cambio.nombre || cambio.codigo)) || item.nombre || item.producto_id
    };
  });
  const aplicados = mapear(src.aplicados);
  const pendientes = mapear(src.pendientes);
  const rechazados = mapear(src.rechazados);
  const cerrados = mapear(src.cerrados);
  return {
    aplicados,
    pendientes,
    rechazados,
    cerrados,
    parcial: src.parcial === true || rechazados.length > 0
  };
}
